import React from 'react';

const Membership: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Devenir membre</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Rejoignez notre communauté de femmes leaders engagées pour le bien-être de la femme et de l'enfant
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-6">Pourquoi devenir membre ?</h2>
              <p className="text-lg mb-8">
                En rejoignant MoreLove, vous faites partie d'une communauté internationale de femmes 
                chrétiennes leaders, unies par la mission de partager l'amour de Jésus-Christ et 
                d'améliorer la vie des femmes et des enfants.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              <div className="card">
                <h3 className="text-xl font-bold mb-4 text-primary">Avantages</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Appartenance à un réseau international de femmes chrétiennes</li>
                  <li>Participation aux programmes d'édification spirituelle</li>
                  <li>Accès aux formations et ateliers de développement</li>
                  <li>Opportunités de bénévolat et de service communautaire</li>
                  <li>Soutien dans vos projets personnels et professionnels</li>
                  <li>Carte de membre officielle "PLUS D'AMOUR"</li>
                </ul>
              </div>
              <div className="card">
                <h3 className="text-xl font-bold mb-4 text-primary">Qui peut devenir membre ?</h3>
                <p className="mb-4">
                  MoreLove accueille toutes les femmes qui :
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Partagent notre foi chrétienne et nos valeurs</li>
                  <li>Sont passionnées par le bien-être des femmes et des enfants</li>
                  <li>Souhaitent s'engager dans des actions concrètes</li>
                  <li>Désirent grandir spirituellement et servir leur communauté</li>
                </ul>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-6 text-center">Carte de membre</h2>
              <div className="card">
                <p className="mb-4">
                  Chaque membre reçoit une carte officielle "PLUS D'AMOUR" comportant :
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-6">
                  <li>Nom et prénom</li>
                  <li>Date de naissance</li>
                  <li>Numéro d'identification</li>
                  <li>Nationalité</li>
                  <li>Profession</li>
                  <li>Date d'émission et d'expiration</li>
                </ul>
                <p>
                  Cette carte symbolise votre appartenance à notre organisation et vous identifie 
                  comme membre officiel de MoreLove Inc.
                </p>
              </div>
            </div>

            {/* Membership Form */}
            <div>
              <h2 className="text-3xl font-bold mb-6 text-center">Formulaire d'adhésion</h2>
              <div className="card">
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                        Prénom
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                        Nom
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                        Téléphone
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="dob" className="block text-sm font-medium text-gray-700 mb-1">
                      Date de naissance
                    </label>
                    <input
                      type="date"
                      id="dob"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="nationality" className="block text-sm font-medium text-gray-700 mb-1">
                      Nationalité
                    </label>
                    <input
                      type="text"
                      id="nationality"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="profession" className="block text-sm font-medium text-gray-700 mb-1">
                      Profession
                    </label>
                    <input
                      type="text"
                      id="profession"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                      Pourquoi souhaitez-vous rejoindre MoreLove ?
                    </label>
                    <textarea
                      id="message"
                      rows={4}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn-primary">
                      Soumettre ma demande
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Membership;
